import React, { useState, useMemo, useEffect } from "react";
import { Card, CardBody, NavItem, NavLink, Badge } from "reactstrap";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer"; // Yolunuzu kontrol edin

const SonIslemler = ({ history }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [currentPages, setCurrentPages] = useState([]);

  useEffect(() => {
    setCurrentPages(history);
  }, [history]);

  const toggleTab = (tab, filterType) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      if (filterType === "All") {
        setCurrentPages(history);
      } else {
        setCurrentPages(history.filter((data) => data.type === filterType));
      }
    }
  };

  const columns = useMemo(() => [
    { 
      header: "İşlem No", 
      accessorKey: "idno", 
      cell: c => <span className="fw-bold text-primary">{c.getValue()}</span> 
    },
    { 
      header: "Tarih", 
      accessorKey: "date", 
      cell: c => c.getValue() ? new Date(c.getValue()).toLocaleDateString("tr-TR", {day: 'numeric', month: 'long', year: 'numeric'}) : "-" 
    },
    { 
      header: "Tip", 
      accessorKey: "type",
      cell: c => (
        <Badge color={c.getValue() === "Gelir" ? "success" : (c.getValue() === "Bekleyen" ? "warning" : "danger")} className="px-2 py-1">
          {c.getValue()}
        </Badge>
      )
    },
    { 
      header: "Açıklama / Notlar", 
      accessorKey: "user" 
    },
    { 
      header: "Tutar", 
      accessorKey: "amount", 
      cell: c => <span className="fw-bold text-dark">{parseFloat(c.getValue()).toLocaleString('tr-TR')} TL</span> 
    },
    { 
      header: "Durum", 
      accessorKey: "status",
      cell: c => (
        <span className={c.getValue() === "Tamamlandı" || c.getValue() === "Onaylandı" ? "text-success fw-semibold" : "text-warning fw-semibold"}>
          {c.getValue()}
        </span>
      )
    },
  ], []);

  return (
    <Card className="shadow-sm border-0">
      <CardBody>
        <h4 className="card-title mb-4">Sistemdeki Son Para Hareketleri</h4>
        <ul className="nav nav-tabs nav-tabs-custom mb-4">
          <NavItem>
            <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1", "All")} style={{cursor:'pointer'}}>
              Tümü
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2", "Gelir")} style={{cursor:'pointer'}}>
              Gelirler (Onaylananlar)
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3", "Bekleyen")} style={{cursor:'pointer'}}>
              Bekleyen İşlemler
            </NavLink>
          </NavItem>
        </ul>

        {currentPages && currentPages.length > 0 ? (
          <TableContainer
            columns={columns}
            data={currentPages}
            isGlobalFilter={true}
            isPagination={true}
            isCustomPageSize={false}
            customPageSize={10}
            SearchPlaceholder="İşlem veya açıklama ara..."
            tableClass="table-bordered align-middle nowrap w-100 mb-0 text-center"
            theadClass="table-light"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            pagination="pagination pagination-rounded justify-content-end mb-2"
          />
        ) : (
          <div className="text-center py-4 text-muted">Bu kategoriye ait işlem bulunamadı.</div>
        )}
      </CardBody>
    </Card>
  );
};

export default SonIslemler;